export const productName = 'MEGAPACK GESTIÓN CULTURAL LISTO™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/3VMh3feXwdjW4EPa4FgGeq/MOCKUP.png';

export const baseUrl = 'https://www.centralpack.shop/cart/54100729528638:1';
export const premiumUrl = 'https://www.centralpack.shop/cart/54100732543294:1';

export const baseItems = [
  'TOMO 1: Fundamentos de la Gestión Cultural',
  'TOMO 2: Diseño y Planificación de Proyectos Culturales',
  'TOMO 3: Producción y Organización de Eventos Culturales',
  'TOMO 4: Gestión de Instituciones y Espacios Culturales',
  'TOMO 5: Comunicación y Marketing Cultural',
  'TOMO 6: Innovación Cultural y Tendencias 2026',
  'BONO 1: Banco de 150 Proyectos Culturales Listos para Adaptar',
  'BONO 2: 80 Formularios y Recursos Administrativos Editables',
  'BONO 3: 300 Actividades Listas para el Aula',
  'BONO 4: Kit Completo de Evaluaciones (56 instrumentos)',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const premiumItems = [
  'UPSELL 1 — Gestión Cultural Profesional en la Era Digital: masterclass de IA para gestores culturales, 80+ prompts especializados, Sistema CULTURA 360° para redes, manual de emprendedurismo cultural, modelos de negocio, personal branding y plan de 90 días',
  'UPSELL 2 — Pack Interior Argentino: guías regionales completas para NOA, NEA, Cuyo, Patagonia, Pampa y Litoral, financiamiento para municipios pequeños, comunicación con recursos limitados, patrimonio regional y plan de desarrollo cultural 2026-2028',
  'Framework GESTIO-IA con flujos de trabajo completos y código de buenas prácticas éticas',
  'Sistema CULTURA 360°: 5 pilares de contenido, 7 formatos de Reels, analytics y monetización',
  'Estrategias de negociación con municipios, patrocinio local y crowdfunding comunitario',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const checklist: Array<[string, string]> = [
  ['Contenido 100% argentino', 'FNA, CONABIP, INT, INCAA, INAMU, Ministerio de Cultura, Constitución Nacional, leyes culturales vigentes y diseños curriculares provinciales.'],
  ['Material imprimible', 'Listo para usar en el aula o entregar directamente al alumno.'],
  ['Formularios y plantillas reales', 'Proyectos, presupuestos, convenios y rendiciones adaptados a Argentina 2026.'],
  ['Casos prácticos resueltos paso a paso', 'Con datos reales del campo cultural argentino.'],
  ['Vocabulario técnico explicado', 'Sin jerga innecesaria, accesible para todos los niveles.'],
  ['Conexión con la actualidad', 'IA en cultura, eventos híbridos, economía naranja, crowdfunding, TikTok cultural y sustentabilidad.'],
  ['Historia y contexto argentino', 'Desde los orígenes de la gestión cultural hasta las tendencias 2026.'],
  ['4 bonos estratégicos', 'Proyectos, formularios, actividades y evaluaciones.'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios.'],
  ['Acceso inmediato', 'Descarga directa tras la compra.'],
  ['Actualizaciones gratuitas', 'Acceso de por vida al material.'],
];
